var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svgicon',{staticClass:"micon",style:(_vm.style),attrs:{"name":_vm.name,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }